import React from "react"

export const Table = ({ content }) => {
  return (
    <div
      className="columns is-centered is-mobile mt-4 mb-6"
    >
      <div className="column is-full">
        <div className="table-container is-size-7">
          <div
            className="article-table"
            dangerouslySetInnerHTML={{ __html: content }}
          ></div>
        </div>
      </div>
    </div>
  )
}
